<template>
  <div class="container-fluid">
    <div class="page-content">
      <div class="page-content--wrap">
        <div class="page-content--body user-status">
          <div class="page-content--body-right">
            <div class="card--notify-block notify-orange mx-0 mb-5">
              Выполняйте условия и повышайте Ваш статус.
              Это позволит получить больше привилегий.
            </div>
            <v-card outlined>
              <v-card-text>
                <div class="user-status--wrap">
                  <div
                    v-for="status in statuses"
                    :key="status.id"
                    :class="[checkIfStatusCompleted(status) ? 'done' : '']"
                    class="user-status--point"
                  >
                    <div class="user-status--point-title">
                      {{ status.title }}
                    </div>
                    <div class="user-status--point-about">
                      <span class="user-status--point-about-text">
                        Коэффициент начисления баллов {{ status.rate }}:1 за
                        регистрацию оборудования
                      </span>
                      <v-menu
                        v-model="menu[status.id]"
                        :close-on-content-click="false"
                        offset-x
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-if="status.description"
                            class="btn-blue"
                            color="primary"
                            @click="openMenu(status)"
                          >
                            <i class="ico-mob">
                              <img
                                alt=""
                                src="../../assets/images/ico-info.svg"
                              />
                            </i>
                            <span class="hide-mob">Подробнее</span>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  style="font-weight: bold; text-align: center"
                                >
                                  Подробная информация
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>

                          <v-list class="information-list">
                            <v-list-item>
                              <v-list-item-title>{{
                                status.description
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </div>
                    <div
                      v-for="option in status.options"
                      :key="option.id"
                      class="user-status--point-task"
                    >
                      <div
                        v-if="option.need === undefined"
                        :class="[
                          option.check ? 'done' : '',
                          option.goto_url ? 'clickable' : '',
                        ]"
                        class="user-status--point-checks"
                      >
                        <span
                          :title="option.goto_url ? 'Перейти к разделу' : ''"
                          @click="goToUrl(option.goto_url)"
                          >{{ option.label }}</span
                        >
                      </div>
                      <div
                        v-if="option.need !== undefined"
                        :class="[
                          option.check ? 'done' : '',
                          option.goto_url ? 'clickable' : '',
                        ]"
                        class="user-status--point-checks"
                      >
                        <span
                          :title="option.goto_url ? 'Перейти к разделу' : ''"
                          @click="goToUrl(option.goto_url)"
                          >{{ option.label }}</span
                        >
                      </div>
                      <div
                        v-if="option.need !== undefined"
                        class="user-status--point-line"
                      >
                        <div class="user-status--point-line-action">
                          <v-progress-linear
                            :value="
                              (100 / option.need) * parseInt(option.value)
                            "
                            height="8"
                            rounded
                          ></v-progress-linear>
                        </div>
                        <div class="user-status--point-line-complete">
                          {{ option.value }} выполнено
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page1',
  computed: {
    /** Статусы */
    statuses() {
      return this.$store.state.app.statuses;
    },
  },
  data() {
    return {
      menuItems: [
        { title: 'Главная', icon: 'mdi-home-outline' },
        { title: 'Портфолио', icon: 'mdi-image-multiple' },
        { title: 'Чат с менеджером', icon: 'mdi-forum-outline' },
        { title: 'Специализации', icon: 'mdi-folder-star-outline' },
        { title: 'Мои работы', icon: 'mdi-domain' },
        { title: 'Обучение (тесты)', icon: 'mdi-school-outline' },
        { title: 'Новости', icon: 'mdi-newspaper' },
        { title: 'Где купить', icon: 'mdi-shopping-outline' },
        { title: 'Расписание семинаров', icon: 'mdi-format-list-checkbox' },
        { title: 'Помощь', icon: 'mdi-help-circle-outline' },
        { title: 'Обращения', icon: 'mdi-relative-scale' },
        { title: 'ЧаВо', icon: 'mdi-frequently-asked-questions' },
        { title: 'Призы', icon: 'mdi-license' },
        { title: 'Мои монтажи', icon: 'mdi-android-studio' },
      ],
      navItems: [
        { title: 'Персональные данные', icon: 'mdi-account', class: 'active' },
        { title: 'Информация о компании', icon: 'mdi-information-variant' },
        { title: 'Изменение пароля', icon: 'mdi-lock-outline' },
      ],
      menuMob: null,
      small: false,
      smaller: false,
      searchShow: false,
      searchArea: false,
      submenuBtn: false,
      userAva: false,
      menu: { 1: false, 2: false, 3: false, 4: false },

      // Статусы
      statuses: [],
    };
  },
  created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  mounted() {
    this.$store.getters.axl
      .get('/profiles/api/profile-statuses/my')
      .then((response) => {
        this.statuses = response.data.items;
      });
    this.$store.dispatch('SetTitle', 'Мой статус');
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    goToUrl(url) {
      this.$router.push(url);
    },
    // Проверить, что пользователь выполнил условия для получения статуса
    checkIfStatusCompleted(status) {
      if (status.options.length === 0) {
        return true;
      }
      return status.options.every(option => option.check);
    },
    // Дата получения статуса
    getStatusDate(status) {
      return new Date(status.created_at).toLocaleDateString();
    },
    // Открыть меню с подробной информацией
    openMenu(status) {
      Object.keys(this.menu).forEach((key) => {
        this.menu[key] = parseInt(key, 10) === status.id;
      });
    },
    onResize() {
      this.small = window.innerWidth <= 1024;
      this.userAva = window.innerWidth <= 1024;
      this.smaller = window.innerWidth <= 599;
      this.searchShow = window.innerWidth <= 599;
      // console.log(this.small ? this.menuMob : false);
    },
  },
};
</script>

<style lang="scss" src="./status.scss"></style>

<style lang="scss" scoped>
.information-list {
  max-width: 300px;
  ::v-deep {
    .v-list-item__title {
      text-align: justify;
      white-space: normal;
      font-family: Arial;
      line-height: inherit;
    }
  }
}
</style>
